module.exports = __webpack_public_path__ + "static/media/card.a3d22ae6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/silicon-valley/card.jpg
// module id = 957
// module chunks = 27